import PropTypes from 'prop-types'
import React from 'react'
import StatusBadge from '../../../../../components/StatusBadge/StatusBadge'
import { STATUS_BADGE_VARIANT_BY_TONE, TONE } from '../../data/constants'

export default function Chip({ tone = TONE.NEUTRAL, children, className = '' }) {
  const variant = STATUS_BADGE_VARIANT_BY_TONE[tone] ?? 'secondary'

  return (
    <StatusBadge variant={variant} className={className}>
      {children}
    </StatusBadge>
  )
}

Chip.propTypes = {
  tone: PropTypes.oneOf(Object.values(TONE)),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}
